import { render, staticRenderFns } from "./evaluaciones-coevaluacion.vue?vue&type=template&id=313be283"
import script from "./evaluaciones-coevaluacion.vue?vue&type=script&lang=js"
export * from "./evaluaciones-coevaluacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports